import { dosableldn } from './dosable/flow';
import { ldn } from './initial/flow';

const LDNFlows = {
  ldn,
  dosableldn
};

export default LDNFlows;
